	(function() {
    var countryCode = $('html').data('countrycode');
	if( !document.querySelector('.GPC0009')) return false; /* LGEGMC-458 , LGEGMC-824 20200730 modify */
	//if(!document.querySelector('.GPC0009') && OBS_LOGIN_FLAG != 'Y') return false;
	//LGEIS-202 ADD
	var price = $('.GPC0009').find('.pdp-visual-image').attr('data-price');
	if(price == '.' || price == '.00' || price == '0.0' || price == '0'){
		price ='';
	}
	var msrp = $('.js-compare').attr('data-msrp');
	if(msrp == '.' || msrp == '.00' || msrp == '0.0' || msrp == '0'){
		msrp ='';
	}
	//LGEIS-202 ADD
	var currency = $('.currency-code').val();
	if(currency =='component-currency-code'){
		currency='';
	}

	var salesModelCode =  $('.js-compare').attr('data-model-salesmodelcode');
	var modelCode	=  $('.js-compare').attr('data-model-id');
	
	var $nav = $('.navigation');
	var obsGroupName = '';
	 if ($nav.length > 0 && (window.location.href.indexOf('/oauth/') == -1 || document.querySelector('.obsSelectCountry'))) {
		var loginURL = $nav.eq(0).data('login-check'); /* LGEKZ-111 */
		//var loginURL = '/lg5-common-gp/data-ajax/mkt/loginInfo.json'
		if (loginURL) {
				$.ajax({
					type: "POST", 
					url:loginURL,
					dataType:"json",
					async: false,
					
					 success : function(data) {
						//PJTGADL-2
							if(data.user.group!='' && data.user.group!=null){
								obsGroupName = data.user.group;
							} else{
								if($('.navigation').hasClass('b2c')){
									obsGroupName = 'B2C';
								} else{
									obsGroupName = 'B2B';
								}
							}
					 }
				});
	  }
	}
	//LGEIS-202 ADD
	var standard = {
		event				: 'detail',
		pageType 			: $('.GPC0009').length ? 'pdp' : 'nonPdp',
		$productsInfo 		: $('.products-info'),
		displayName			: nvl_def($('.pdp-summary-area .pdp-info.desktop-info').find('.model-title').text()),
		
		siteType			: (typeof standardData === "undefined") ? '' : standardData.siteType,
		std_lv1				: (typeof standardData === "undefined") ? '' : standardData.level1,
		std_lv2				: (typeof standardData === "undefined") ? '' : standardData.level2,
		std_lv3				: (typeof standardData === "undefined") ? '' : standardData.level3,
		
		pagePurpose 		: _dl.page_name.page_purpose,
		sku					: _dl.page_name.sku,
		bu 					: _dl.page_name.bu,
		country_code 		: _dl.country_code,
		page_category_l1	: _dl.page_category_l1,
		page_category_l2	: _dl.page_category_l2,
		page_category_l3	: _dl.page_category_l3,
		page_category_l4	: _dl.page_category_l4,
		language 			: _dl.language_code,
		superCategory 		: $('.GPC0009').find('.pdp-visual-image').attr('data-category-name'),
		primaryCategory 	: _dl.page_name.category,
		subCategory 		: _dl.page_name.sub_category,
		name		 		: salesModelCode,
		//variant		 		: (typeof _dl.products === "undefined" ||  typeof _dl.products[0] === "undefined") ? null : _dl.products[0].sales_model_code.substring(_dl.products[0].sales_model_code.indexOf('.')+1, _dl.products[0].sales_model_code.length),
		variant		 		: (salesModelCode == '' || salesModelCode.indexOf('.') == -1) ? null : salesModelCode.substring(salesModelCode.indexOf('.')+1, salesModelCode.length),
		modelCode	 		: modelCode,
		productDetailArray 	: new Array(),
		quantity			: 0,
		price				: price,
		currency            : currency,
		obsGroup            : obsGroupName,
		metric4             : msrp,
		ecommerce			: new Object(),
		productsObj			: new Object(),
		productDetailArray	: new Array(),
		
		
		inInit: function() {
			//LGEGMC-824
			standard.ecommerce.currencyCode = standard.currency;
			standard.productsObj.id = standard.sku;
			standard.productsObj.name = standard.name;
			standard.productsObj.price = nvl(standard.price,'0');
            standard.productsObj.brand = standard.std_lv2;/* LGEGMC-458 20200730 modify */
            standard.productsObj.category = standard.std_lv1;
            standard.productsObj.variant = standard.variant;
            standard.productsObj.dimension124 = standard.std_lv3;
            standard.productsObj.dimension125 = standard.superCategory;
            standard.productsObj.dimension126 = standard.modelCode;
            standard.productsObj.dimension127 = standard.displayName;
            standard.productsObj.dimension185 = standard.obsGroup
            standard.productsObj.metric4      = standard.metric4
            
            standard.productDetailArray.push(standard.productsObj);
            standard.ecommerce.detail = new Object();
            standard.ecommerce.detail.products = standard.productDetailArray;
			
			standard.inAddData();
		},
		
		inAddData: function() {
			dataLayer.push({
		        'event': standard.event,
		        'siteType': nvl(standard.siteType, 'B2C'),
		        'pagePurpose': nvl(standard.pagePurpose, standard.pageType),
		        'ecommerce': standard.ecommerce
		    });
		}
	}
	standard.inInit();
	}());


function replaceAll(str, searchStr, replaceStr) {
	
   	return str.split(searchStr).join(replaceStr);
};

function nvl(str, defaultStr){
	var check = str+"";
	var result = "";
	check = check.trim()
	if(check=="" || check==null || check == "null" || check=="undefined"){
		result = defaultStr;
	}else{
		result = check;
	}
	return result ;
}

function nvl_def(str){
	var result = str+"";
	result = result.trim()
	if(result=="" || result==null || result == "null" || result=="undefined")
		result = "" ;
	
	result = result.replace(/\s\s+/g, ' ')
	result = replaceAll(result,'_',' ')
	return result ;
}
